<template>
<div>
  <user :visible.sync="userVisible"></user>

  <div class="dokhlab-top">
    <div class="dokhlab-top-home" @click="redirect(`${$store.state.host}/dokhlab/#/home`)">Dokholyan Lab</div>
    <div class="dokhlab-top-research" @click="redirect(`${$store.state.host}/dokhlab/#/research`)">Research</div>
    <div class="dokhlab-top-publications" @click="redirect(`${$store.state.host}/dokhlab/#/publications`)">Publications</div>
    <div class="dokhlab-top-services" @click="redirect(`${$store.state.host}/dokhlab/#/tools`)">Services</div>
    <div class="dokhlab-top-login" v-if="$store.state.user!=''" @click="userVisible=true" style="cursor:pointer">{{$store.state.user.username}}</div>
    <div v-else class="dokhlab-top-login" style="cursor:pointer" @click="userVisible=true">Login</div>
  </div>

  <div class="content">
    <router-view/>
  </div>
</div>
</template>

<script>
import User from '../User'
import utils from './utils.js'

export default {
  name: 'app',

  data () {
    return {
      userVisible: false
    }
  },

  components: {
    User
  },

  methods: {
    ...utils.mapUtils(['redirect'])
  },

  mounted () {
    this.$store.dispatch('autoLogin')
    this.$store.commit('setkv', {k: 'server', v: 'drift'})
  }
}
</script>

<style>

body {
  overflow-y: auto;
  font-size: 12px;
  height: 100%;
  background-color: white;
  width: 100%;
  margin: 0px;
  padding: 0px;
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Oxygen-Sans,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue","Source Sans Pro",sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

li.menu-item {
  padding: 0 20px;
  font-size: 14px;
  height: 56px;
  line-height: 56px;
  cursor: pointer;
}

</style>

<style lang="scss" scoped>

@import "./styles/theme.scss";

#app {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
  position: relative;
}

.dokhlab-top {
  height: 30px;
  background-color: #333333;
  color: white;
  display: flex;
  align-items: center;
  flex-direction: row;
  font-weight: bold;
}

.dokhlab-top-home {
  padding: 0px 20px;
  cursor: pointer;
  height: 100%;
  line-height: 30px;
}

.dokhlab-top-home:hover {
  background-color: #7c7c7c;
}

.dokhlab-top-research {
  padding: 0px 20px;
  cursor: pointer;
  height: 100%;
  line-height: 30px;
}

.dokhlab-top-research:hover {
  background-color: #7c7c7c;
}

.dokhlab-top-publications {
  padding: 0px 20px;
  cursor: pointer;
  height: 100%;
  line-height: 30px;
}

.dokhlab-top-publications:hover {
  background-color: #7c7c7c;
}

.dokhlab-top-services {
  padding: 0px 20px;
  cursor: pointer;
  height: 100%;
  line-height: 30px;
}

.dokhlab-top-services:hover {
  background-color: #7c7c7c;
}

.dokhlab-top-login {
  margin-left: auto;
  margin-right: 10px;
}

.content {
  width: 100%;
}

li.menu-item:hover {
}

li.menu-item.is-active {
  font-weight: bold;
  color: #67c23a;
}

li.menu-item * {
  vertical-align: middle;
}

li.menu-item i {
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
  color: #878d99;
}

li.menu-item.is-active i {
  color: inherit;
}

li.menu-item i.submenu-arrow {
  position: absolute;
  right: 20px;
  top: 50%;
  margin-top: -7px;
  font-size: 12px;
}

div.el-card__header {
  padding: 0px 20px;
}

</style>

